<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Payment Modes | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-md-12 center center-block" align="center">

  <div class="card card-danger card-outline">
  	<div class="card-header">
  		<button @click="syncPM" class="btn btn-danger float-right">Sync Payment Modes</button>
  		<button @click="PMExport(true)" class="btn btn-danger float-right">PM Template</button>
  		<button @click="PMExport(false)" class="btn btn-danger float-right">PM Export</button>
  		<button @click="uploadPrompt" class="btn btn-danger float-right">PM Import</button>
  	</div>
		<div class="card-body overflow-auto">
      <div class="col-md-12 float-left">
			<div class="row">
				
	</div>
	<div class="row">
				<!--<div class="col-sm-4">
      		<div class="form-group">
      			<button class="btn btn-danger" @click="reset"><i class="fa fa-times"></i> Reset</button>
      		</div>
      	</div>-->

      	<div class="col-sm-4">
      		<div class="form-group">
      			<button class="btn btn-danger" @click="getPMS('/api/getSAPPaymentModes')"><i class="fa fa-search"></i> Search</button>
      		</div>
      	</div>
      </div>
      </div>

      <img v-if="pms == ''" src="">

			<!-- content here -->
			<datatable style="margin-top:1%;" :columns="columns" v-else>
				<tbody>
					<tr v-for="p in pms" :key="p.id">
						<td>{{p.payment_code}}</td>
						<td>{{p.payment_name}}</td>
						<td>{{p.status}}</td>
						<td>
							<button class="btn btn-danger" v-if="p.status == 'Active'" @click="changeStatus(p.id, 'Inactive')">Disable</button>
							<button class="btn btn-success" v-else @click="changeStatus(p.id, 'Active')">Enable</button>
						</td>
					</tr>
				</tbody>
			</datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getPMS(pagination.prevPageUrl)"
        @next="getPMS(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>


</div>
<!-- row end -->
    </section>
    <!-- /.content -->


<div class="modal" tabindex="-1" role="dialog" id="uploadModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Branch Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div :class="['form-group', errors.link ? 'has-error' : '']">
							<label for="file">Excel File</label>
							<input class="form-control" id="file" type="file" ref="file" name="link" placeholder="Upload Excel" @change="addFile">
							<span v-if="errors.link" :class="['badge bg-danger']">Please add an excel file.</span>
						</div>
					</div>
					<button class="btn btn-sm btn-primary" @click="uploadPMFile"> Submit</button>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

    <loading
     :show="lshow"
     :label="llabel">
 </loading>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../../datatable.vue';
    import Pagination from '../../pagination.vue';
    import { saveAs } from 'file-saver';
    import loading from 'vue-full-loading';
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {datatable:Datatable, pagination:Pagination, loading},

        created(){
        	this.getPMS();
        },

        data(){
        	let columns = [
      			{width:'25%', label:'Payment Code', name:'PaymentCode'},
      			{width:'25%', label:'Payment Name', name:'PaymentName'},
      			{width:'25%', label:'Status', name:'Status'},
      			{width:'25%', label:'View More', name:'ops'},
      		];

      		return {
      			columns: columns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		pms: [],
         		results: '',
         		lshow: false,
           	llabel: 'Syncing. Do not close or change this page...',
           	file: '',
           	link: '',
           	errors: []
      		}
        },

        methods: {
        	syncPM(){
        		toast.fire({
        			icon: 'warning',
        			title: 'Wait For Syncing to be Over'
        		});
        		this.lshow = true;
        		axios.post("/api/syncSAPPaymentModes")
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Synced '+response.data+' entries'
        			});
        			this.getPMS();
        			this.lshow = false;
        		})
        		.catch(() => {
        			toast.fire({
        				icon: 'error',
        				title: 'Syncing Failed!'
        			});
        		})
        	},

        	PMExport(template){
        		axios({
		      		url: "/api/PMExport",
		      		data: {template: template},
		      		method: 'post',
		      		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "payment_modes.xlsx");
        		})
        	},

        	uploadPrompt(){
        		$("#uploadModal").modal("show");
        	},

        	addFile(){
    				this.file = this.$refs.file.files[0];
    				this.link = this.file;
    			},

    			uploadPMFile(){
    				var formData = new FormData();
    				formData.append('file', this.link);
    				toast.fire({
        			icon: 'warning',
        			title: 'Wait For Syncing to be Over'
        		})
        		this.lshow = true;
    				axios({
    					method: 'post',
    					url: '/api/PMImport',
    					data: formData,
    					headers: {'Content-Type': 'multipart/form-data'},
    				})
    					.then(()=>{
      	     		toast.fire({
      		      	type: 'success',
                	title: 'Syncing Success'
            		});
            		this.errors = [];
            		this.lshow = false;
            		this.getPMS();
    				})
    				.catch((error)=>{
    					this.lshow = false;
            	toast.fire({
      	      	type: 'error',
              	title: 'Syncing Failed'
            	});
            	this.errors = error.response.data.errors;
          	})
    			},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	getPMS(url="/api/getSAPPaymentModes"){
        		axios.post(url, {results: this.results})
        		.then(response => {
        			this.pms = response.data.data.data;
        			this.configPagination(response.data.data);
        		})
        	},

        	view(man){
        		this.form.fill(man);
        		$("#viewModal").modal("show");
        	},
        	
        	changeStatus(id, status){
        		axios.post("/api/changeSAPPMStatus", {id: id, status: status})
        		.then(response => {
        			if(response.data = 200)
        				this.getPMS();
        		})
        	}

        	/*reset(){
        		this.results = '';
        		this.branch = '';
        		this.name = '';
        		this.category = '';
        	},*/
        }
    }
</script>
